import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Anticipated Response of Change by Team',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Anticipated Response of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Positive',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'positiveHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'positiveFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'positiveTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'positiveChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'positiveOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Neutral',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'neutralHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'neutralFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'neutralTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'neutralChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'neutralOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Negative',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'negativeHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'negativeFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'negativeTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'negativeChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'negativeOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Mixed',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'mixedHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'mixedFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'mixedTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'mixedChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'mixedOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Unknown',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'unknownHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'unknownFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'unknownTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'unknownChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'unknownOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Team',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    positiveHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
